import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RouteService } from '../../../../routing/services/route.service';

@Component({
    selector: 'chassis-form-create-page',
    templateUrl: './create.page.html',
    styleUrls: ['./create.page.scss']
})
export class FormCreatePage implements OnInit {

    public entityId = null;

    public routePrefix = 'entities.forms';

    protected routeService: RouteService;

    public constructor(private route: ActivatedRoute, private injector: Injector) {
        this.routeService = this.injector.get(RouteService);
    }

    public ngOnInit() {
        this.entityId = this.route.snapshot.params['entity'];
    }

    public onSavedAttributeSet($event) {
        this.routeService.navigate(this.routePrefix + '.' + 'edit', [this.entityId, $event.id]);
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/entities/forms/create/create.page.ts